import React from 'react';

import SalesOrderList from '../../../../pages/sales/salesList/SalesOrderList';

const SalesOrdersInCustomer = ({ id }: { id?: string }) => {
  return id ? <SalesOrderList independent={false} customerId={id} showAllStatuses showTypeSwitches /> : null;
};

export default SalesOrdersInCustomer;
